import { configureStore } from '@reduxjs/toolkit';
import patientsReducer from './patientsSlice';
import meetingsReducer from './meetingsSlice';
import leadsReducer from './leadsSlice';

export const store = configureStore({
  reducer: {
    patients: patientsReducer,
    meetings: meetingsReducer,
    leads: leadsReducer,
  }
});

// types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;